/**
 * Export component file to be used on project
 */

import HeaderButton from './HeaderButton';
export default HeaderButton;